var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgChat = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("ellipse", {
    cx: 50.306,
    cy: 48.813,
    fill: "var(--color-neutral-70)",
    rx: 33.339,
    ry: 25.247,
    transform: "rotate(8 50.306 48.813)"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M43.814 72.886c1.15.247 2.34.466 3.537.617 7.016.934 13.738.098 19.463-2.079 6.2 5.291 13.173 6.528 13.173 6.528s-3.802-5.844-3.86-12.054c3.928-3.49 6.534-7.938 7.214-13.015 1.836-13.789-11.289-26.922-29.31-29.318-15.343-2.054-29.278 4.313-34.245 14.715"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M43.814 72.886c1.15.247 2.34.466 3.537.617 7.016.934 13.738.098 19.463-2.079 6.2 5.291 13.173 6.528 13.173 6.528s-3.802-5.844-3.86-12.054c3.928-3.49 6.534-7.938 7.214-13.015 1.836-13.789-11.289-26.922-29.31-29.318-15.343-2.054-29.278 4.313-34.245 14.715"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeDasharray: "4 4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M45.978 28.686c-7.966.525-15.064 3.673-19.15 8.529M49.791 68.313c5.322.456 10.512-.202 15.112-1.97"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.121 68.01s3.047-2.638 4.074-6.091c-1.639-2.56-2.383-5.457-1.94-8.375 1.17-7.956 10.556-13.163 20.957-11.616 10.4 1.548 17.871 9.244 16.702 17.2C47.746 67.082 38.36 72.29 27.96 70.742c-4.048-.603-7.66-2.138-10.479-4.248-4.285 1.933-8.359 1.515-8.359 1.515Z"
  }), React.createElement("circle", {
    cx: 21.5,
    cy: 56.5,
    r: 2.5,
    fill: "var(--color-neutral-70)"
  }), React.createElement("circle", {
    cx: 29.5,
    cy: 56.5,
    r: 2.5,
    fill: "var(--color-neutral-70)"
  }), React.createElement("circle", {
    cx: 37.5,
    cy: 56.5,
    r: 2.5,
    fill: "var(--color-neutral-70)"
  }));
};
export default SvgChat;